module.exports = __webpack_public_path__ + "images/icons_v2/convenience-2d484203.svg";